import { DxFlow_Fwd_Lnk } from '../models/domain/dxflow_fwd_lnk';
import { CommonEnums } from '../common.enums';

export class DxFlow_Fwd_LnksUtil {
    private static instance: DxFlow_Fwd_LnksUtil;

    static getInstance() {
        if (!DxFlow_Fwd_LnksUtil.instance) {
            DxFlow_Fwd_LnksUtil.instance = new DxFlow_Fwd_LnksUtil();
        }

        return DxFlow_Fwd_LnksUtil.instance;
    }

    /**
    * DxFlow_Fwd_LnksUtil is a singleton class, so use DxFlow_Fwd_LnksUtil.getInstance() method instead of creating new DxFlow_Fwd_LnksUtil().
    */
    private constructor() {

    }

    getDxFlow_Fwd_LnkKey(dxFlow_Fwd_Lnk: DxFlow_Fwd_Lnk): string {
        return dxFlow_Fwd_Lnk.dxFlow_Id + "." + dxFlow_Fwd_Lnk.obj_Id + "." + dxFlow_Fwd_Lnk.fwd_Lnk_Obj_Id;
    }

    copy(dxFlow_Fwd_Lnks: Array<DxFlow_Fwd_Lnk>): Array<DxFlow_Fwd_Lnk> {
        let dxFlow_Fwd_LnksTmp: Array<DxFlow_Fwd_Lnk> = new Array<DxFlow_Fwd_Lnk>();

        for (let i: number = 0; i < dxFlow_Fwd_Lnks.length; i++) {
            dxFlow_Fwd_LnksTmp.push(dxFlow_Fwd_Lnks[i].copy())
        }

        return dxFlow_Fwd_LnksTmp;
    }

    compare(dxFlow_Fwd_Lnks: Array<DxFlow_Fwd_Lnk>, dxFlow_Fwd_LnksTmp: Array<DxFlow_Fwd_Lnk>): string {
        if (dxFlow_Fwd_Lnks.length != dxFlow_Fwd_LnksTmp.length)
            return 'dxMp_Fwd_Lnks length mismatch.';

        for (let i: number = 0; i < dxFlow_Fwd_Lnks.length; i++) {

            let dxFlow_Fwd_Lnk: DxFlow_Fwd_Lnk = dxFlow_Fwd_Lnks[i] as DxFlow_Fwd_Lnk;
            let dxFlow_Fwd_LnkTmp: DxFlow_Fwd_Lnk = dxFlow_Fwd_LnksTmp[i] as DxFlow_Fwd_Lnk;

            let diffString: string = dxFlow_Fwd_Lnk.compare(dxFlow_Fwd_LnkTmp);
            if (diffString != CommonEnums.defaults.STRING_EMPTY)
                return diffString;
        }
        return '';
    }

    diffDxFlow_Fwd_Lnks(dxFlow_Fwd_Lnks, dxFlow_Fwd_LnksCopy) {

        if (dxFlow_Fwd_Lnks.length != dxFlow_Fwd_LnksCopy.length)
            return 'Length mismatch';

        let dxFlow_Fwd_LnksCopyHMap = [];

        for (let i = 0; i < dxFlow_Fwd_LnksCopy.length; i++) {
            dxFlow_Fwd_LnksCopyHMap[this.toDxFlow_Fwd_LnkString(dxFlow_Fwd_LnksCopy[i])] = dxFlow_Fwd_LnksCopy[i];
        }

        let dxFlow_Fwd_Lnk;
        let dxFlow_Fwd_Lnkstring;

        let dxFlow_Fwd_LnkCopy;
        let dxFlow_Fwd_LnkCopyString;
        for (let i = 0; i < dxFlow_Fwd_Lnks.length; i++) {
            dxFlow_Fwd_Lnk = dxFlow_Fwd_Lnks[i];

            dxFlow_Fwd_LnkCopy = dxFlow_Fwd_LnksCopyHMap[this.toDxFlow_Fwd_LnkString(dxFlow_Fwd_Lnk)];
            if (!dxFlow_Fwd_LnkCopy) return 'dxFlow_Fwd_Lnk Not Found';

            dxFlow_Fwd_Lnkstring = this.toString(dxFlow_Fwd_Lnk);
            dxFlow_Fwd_LnkCopyString = this.toString(dxFlow_Fwd_LnkCopy);

            if (dxFlow_Fwd_Lnkstring != dxFlow_Fwd_LnkCopyString)
                return 'dxFlow_Fwd_Lnks are not Equal';
        }

        return '';
    }

    toDxFlow_Fwd_LnkString(dxFlow_Fwd_Lnk) {
        return dxFlow_Fwd_Lnk.dxFlow_Id + "." + dxFlow_Fwd_Lnk.obj_Id + "." + dxFlow_Fwd_Lnk.fwd_Lnk_Obj_Id;
    }


    copyFrom(dxFlow_Fwd_Lnks: Array<DxFlow_Fwd_Lnk>, dxFlow_Fwd_LnksTmp: Array<DxFlow_Fwd_Lnk>): void {
        let dxFlow_Fwd_LnksMap: Map<string, DxFlow_Fwd_Lnk> = new Map();

        let dxFlow_Fwd_LnksLength: number = dxFlow_Fwd_Lnks.length;
        for (let i: number = 0; i < dxFlow_Fwd_LnksLength; i++) {
            dxFlow_Fwd_LnksMap.set(this.getDxFlow_Fwd_LnkKey(dxFlow_Fwd_Lnks[i]), dxFlow_Fwd_Lnks[i]);
        }

        dxFlow_Fwd_Lnks.splice(0, dxFlow_Fwd_Lnks.length);

        let dxFlow_Fwd_LnksTmpLength: number = dxFlow_Fwd_LnksTmp.length;
        for (let i: number = 0; i < dxFlow_Fwd_LnksTmpLength; i++) {
            let dxFlow_Fwd_LnkTmp: DxFlow_Fwd_Lnk = dxFlow_Fwd_LnksTmp[i] as DxFlow_Fwd_Lnk;
            let dxFlow_Fwd_Lnk: DxFlow_Fwd_Lnk = dxFlow_Fwd_LnksMap.get(this.getDxFlow_Fwd_LnkKey(dxFlow_Fwd_LnkTmp));
            if (dxFlow_Fwd_Lnk) {
                dxFlow_Fwd_Lnk.copyFrom(dxFlow_Fwd_LnkTmp);
            } else {
                dxFlow_Fwd_Lnk = DxFlow_Fwd_Lnk.parse(dxFlow_Fwd_LnkTmp);
            }

            dxFlow_Fwd_Lnks.push(dxFlow_Fwd_Lnk);
        }
    }

    toString(dxFlow_Fwd_Lnks: Array<DxFlow_Fwd_Lnk>): string {
        return '';
    }
}    